<template>
  <div>
    <s-header>
      <div class="mt-3 -mb-3">Daily Count</div>
      <!-- <div class="-mt-8 text-red-700">
          {{ isOrder ? 'Today' : 'Completed' }}
        </div> -->
    </s-header>

    <section
      v-if="!isOrder"
      class="mt-10 text-p1 text-2xl font-semibold text-gray-800 text-left leading-tight max-w-lg border-l-4 border-gray-800 px-6 py-2"
    >
      Today's order has already been submitted, or there are no products to
      order today.
    </section>

    <section v-if="isOrder">
      <order-item
        v-for="(id, index) in orderItemsToday"
        :key="id"
        :index="index"
        :active-item="activeChild"
        :id="id"
        :value="currentOrder[id]"
        :title="products[id].name"
        :subtitle="products[id].question"
        :input-type="products[id].inputType"
        @clicked="activeChild = $event"
        @showProductCountingInfo="
          $modal.show('modal--product-counting-info', $event)
        "
        @putValue="updateCurrentOrderItem"
        class="mt-2"
      />
    </section>

    <div class="mt-6 flex flex-row justify-start">
      <s-button
        v-if="isOrder"
        left-icon="message"
        :class="allCompleted ? 'shadow-lg' : 'opacity-50 cursor-not-allowed'"
        @focus.stop="activeChild = null"
        @click="allCompleted ? submit() : ''"
      >
        Submit
      </s-button>
      <s-button
        v-if="isAdmin && isOrder"
        :class="isOrder ? 'ml-4' : ''"
        left-icon="trash-alt"
        class="shadow-lg"
        @focus.stop="activeChild = null"
        @click="deleteCurrentOrder"
      >
        Delete Order
      </s-button>
      <!-- interesting button effect:     bg-red-400 hover:bg-gray-100 text-gray-400 hover:text-green-200  -->
    </div>

    <div v-if="currentOrderCompleted || !(orderItemsToday && orderItemsToday.length > 0)" class="mt-6 flex flex-row justify-start">
      <s-button left-icon="dashboard" @click="$router.push('/dashboard')">
        Go to Dashboard
      </s-button>
    </div>

    <modal-product-counting-info />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OrderItem from '@/components/OrderItem'
import SHeader from '@/components/SHeader'
import SButton from '@/components/Button'
import ModalProductCountingInfo from '@/components/ModalProductCountingInfo'

export default {
  name: 'OrderingList',
  data: function () {
    return {
      activeChild: null
    }
  },
  components: {
    OrderItem,
    SHeader,
    SButton,
    ModalProductCountingInfo
  },
  computed: {
    ...mapGetters('time', ['weekDay', 'weekDayName']),
    ...mapGetters('user', ['isManager', 'isAdmin']),
    ...mapGetters(['orderItemsToday']),
    ...mapGetters('storeModule', [
      'productsByDays',
      'currentOrder',
      'currentOrderId',
      'currentOrderCompleted'
    ]),
    ...mapGetters('storeModule/orders', ['orderById']),
    ...mapGetters('storeModule/products', ['products']),
    isOrder() {
      if (this.currentOrderCompleted) return false
      if (!this.orderItemsToday.length > 0) return false
      if (!this.currentOrderId) return false
      if (!this.currentOrder) return false
      return true
    },
    allCompleted() {
      if (
        this.orderItemsToday.find(
          (item) =>
            !Object.prototype.hasOwnProperty.call(this.currentOrder, item)
        )
      )
        return false
      return true
    }
  },
  methods: {
    ...mapActions('storeModule', [
      'updateCurrentOrderItem',
      'deleteCurrentOrder'
    ]),
    submit: function () {
      if (this.allCompleted) {
        this.activeChild = null
        this.$modal.show('modal--submit-order', {
          id: this.currentOrderId,
          isInventory: false
        })
      }
    }
  }
}
</script>
